// extracted by mini-css-extract-plugin
export default {"About":"About_About__8zKFX","Tech":"About_Tech__icWga"};